import React from "react";
import { Link } from "react-router-dom";
import { OSH_IMAGES } from "../../lib/worldOsharImages";

const districts = [
  {
    title: "Waterfront District",
    body: "Bridges, harbors, and neon reflections—commerce and contracts along the waterline.",
    img: OSH_IMAGES.districtWaterfront,
  },
  {
    title: "Gladiator Coliseum",
    body: "Bloodline brackets and house banners—where the city hears the crowd roar.",
    img: OSH_IMAGES.districtColiseum,
  },
  {
    title: "Casino Quarter",
    body: "High-stakes floors and velvet lounges—arcade energy with VIP pacing.",
    img: OSH_IMAGES.districtCasino,
  },
  {
    title: "Market & Shopping District",
    body: "Stalls, auctions, and legendary smiths—gear up before the next sortie.",
    img: OSH_IMAGES.districtMarket,
  },
];

const OsharDistricts = () => {
  return (
    <section className="oshar-districts" id="oshar-districts" aria-labelledby="oshar-districts-heading">
      <div className="oshar-inner">
        <header className="oshar-districts__head">
          <div className="oshar-ornament" />
          <h2 id="oshar-districts-heading" className="oshar-section-title">
            DISTRICTS OF OSHAR
          </h2>
          <div className="oshar-ornament" />
        </header>

        <div className="oshar-districts__row">
          {districts.map((d) => (
            <article key={d.title} className="oshar-district">
              <div className="oshar-district__thumb">
                <img src={d.img} alt="" loading="lazy" />
              </div>
              <h3>{d.title}</h3>
              <p>{d.body}</p>
              <Link to="/world/oshar/real-estate" className="oshar-district__btn">
                EXPLORE <i className="fas fa-angle-right" aria-hidden />
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OsharDistricts;
